import { createContext, useContext, useState } from "react";

export const BMKContext = createContext(null);

export const BMKProvider = ({ children }) => {
	const [bmkData, setBMKData] = useState({
		address1: "",
		address2: "",
		address3: "",
		address4: "",
		address5: "",
		postcode: "",
		city: "",
		state: "",
		make: "",
		model: "",
		model_year: "",
		engine_capacity: "",
	});

	return (
		<BMKContext.Provider value={{ bmkData, setBMKData }}>
			{children}
		</BMKContext.Provider>
	);
};
